/**
 * Vuex getters for the "restrict" module.
 *
 * Thin state accessors exposing the restricted-users state as-is.
 */
export default {
    getRestrictedUsers(state) {
        return state.restrictedUsers;
    },
}
